import React from "react";
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

const RoadmapSidebar = () => {
  return(
    <div>
      <hr className="my-3"/>
      <div className="flex flex-col xs:flex-row lg:flex-col xs:items-center">
        <div className="w-36 mx-auto">
          <StaticImage src="../images/roadmap_certificate.png" alt="certificate" /> 
        </div>
        <p className="text-center mb-0 xs:text-left xs:ml-3 lg:text-center">Pass The Exam And Earn The Complete Certification <a href="/" className="font-medium text-ia-indigo-dark underline">Complete Required</a></p>
      </div>
    </div>
  )
}

const ShopifySidebar = () => {
  return(
    <div>
      <hr className="my-3"/>
      <div className="flex flex-col xs:flex-row lg:flex-col xs:items-center">
        <div className="w-36 mx-auto">
          <StaticImage src="../images/shopify_partner.png" alt="shopify partner" />
        </div>
        <p className="text-center mb-0 xs:text-left xs:ml-3 lg:text-center">As a <a href="https://help.shopify.com/en/manual/community/shopify-education-partners" target="_blank" rel="noreferrer" className="font-medium text-ia-indigo-dark underline">Shopify Education Partner</a>, we are proud to announce that eCom Challenge is an approved course by Shopify.</p>
      </div>
    </div>
  )
}

export default function Include(props) {
  const include = props.list;
  return (
    <div className="p-3 md:p-4 bg-white rounded-lg shadow-box">
      <p className="text-ia-indigo-dark font-medium">What’s included?</p>
      {include.map(include =>
        <div className="flex" key={include}>
          <div><FontAwesomeIcon icon={faCheckCircle} className="text-ia-green-default mr-2"/></div>
          <div>{include}</div>
        </div>
      )}
      { props.type === 'roadmap' ? <RoadmapSidebar /> : null }
      { props.partner === 'shopify' ? <ShopifySidebar /> : null }
    </div>
  )
}
